module.exports = __webpack_public_path__ + "img/icon_7th.26e6c2f3.png";